export function getAppConfiguration(): IAppConfiguration {
  return window.netbiz.configuration;
}

export function initAppConfiguration(): void {
  const html = document.querySelector('html') as HTMLElement;
  const configurationJson = html.dataset.reactConfiguration;
  const configuration = JSON.parse(configurationJson!) as IAppConfiguration;
  html.removeAttribute('data-react-configuration');

  if (!('netbiz' in window) || !('configuration' in window.netbiz))
    window.netbiz = { configuration };
}
